module.exports = __webpack_public_path__ + "static/img/news-top-img.a91f464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-top-img.png
// module id = SD7g
// module chunks = 1